<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" title="公司架构" />
    
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <vue2-org-tree 
        :data="treedata"
        collapsable
        @on-expand="onExpand"
        :horizontal="true"/>
        <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
          <img v-lazy="require(`@/assets/cases/${cas.image}`)" alt="Case Image">
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.title}}</p>
            <p class="abstract-content">{{cas.content}}</p>
            <div class="more">
              <router-link
                class="text-decoration"
                :to="{ name: 'companydetails', params: { id: cas.id }}"
              >
                <span>more</span>
                <img src="../assets/img/sanjiao.png" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  methods: {  
    // 组件的方法  
    collapse(list) {  
      var _this = this;  
      list.forEach(function(child) {  
        if (child.expand) {  
          child.expand = false;  
        }  
        if (child.children) {  
          _this.collapse(child.children);  
        }  
      });  
    },  
    onExpand(e, data) {  
      if ("expand" in data) {  
        data.expand = !data.expand;  
        if (!data.expand && data.children) {  
          this.collapse(data.children);  
        }  
      } else {  
        this.$set(data, "expand", true);  
      }  
    }  
  },
  data() {
    return {
      loading: true,
      caseList: [],
      blobUrls: {},
      treedata: {
        id: 0,
        label: "安徽众心集团",
        children: [
          {
            id: 2,
            label: "安达信会计公司",
            children: [
              {
                id: 5,
                label: "总经理"
              },
              {
                id: 6,
                label: "会计"
              },
              {
                id: 9,
                label: "销售经理"
              }
            ]
          },
          {
            id: 3,
            label: "巨龙架业",
            children: [
              {
                id: 7,
                label: "总经理"
              },
              {
                id: 8,
                label: "财务"
              }
            ]
          },
        ]
      }
    };
  },
  mounted() {
    window.console.log("case");
    // this.$http
    //   .get("Cases/GetCasesAll")
    this.$axios.get(`${this.$apiBaseUrl}//findCompany`)
      .then(response => {
        //console.log(response);
        this.caseList = response.data;
        window.console.log(this.caseList);
        this.loading = false;
      })
      .catch(function(error) {
        window.console.log(error);
      });
  }
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>